module.exports = __webpack_public_path__ + "img/refresh.d2a480fd.svg";